/**
 * Logo URLs are stored API-relative (e.g. "/uploads/123.png"), so they must be
 * resolved against NEXT_PUBLIC_API_BASE before they can go in an <img src>.
 *
 * This existed as five separate private copies (CertificatesView,
 * TenantDirectoryView, TemplateCardQr, TemplateDiploma, TemplateDiplomaWide),
 * which is exactly why the branding page was missed - it never got one.
 * Import this instead of writing a sixth.
 *
 * Returns undefined for empty input so callers can conditionally render rather
 * than passing "" to src, which makes the browser refetch the whole page.
 */
export function resolveLogoSrc(raw?: string | null): string | undefined {
  const value = (raw ?? "").trim();
  if (!value) return undefined;
  if (/^(https?:\/\/|data:)/.test(value)) return value;
  if (value.startsWith("/")) {
    const base = (process.env.NEXT_PUBLIC_API_BASE || "").replace(/\/+$/, "");
    return base ? `${base}${value}` : value;
  }
  return value;
}
